module.exports = __webpack_public_path__ + "dist/assets/a41a04bdbd85254bb24f9575b6204ba2.svg";